<!--  -->
<template>
  <div class="course-sku">
    <van-popup v-model="show" position="bottom" :style="{ height: '65%' }" duration="0.18" round>
      <section class="section">
        <h1 class="course-title">
          <span>选择课程</span><van-icon @click="show = false" name="cross" />
        </h1>
        <div class="course-box" v-if="show">
          <PackageCourse
            v-for="(item, key) in packageList"
            :key="key"
            :isOpen="key === 0 ? true : false"
            :packageCourse="item"
            @receivePackageCourse="receivePackageCourse"
          />
        </div>
        <footer class="foot">
          <button :class="{ active: disbaled }" @click="toBuy">确认激活</button>
        </footer>
      </section>
    </van-popup>
  </div>
</template>

<script>
import { resCourseTmall } from '@/api/personal/courseTmall';
import PackageCourse from './packageCourse.vue';

export default {
  components: {
    PackageCourse,
  },
  data() {
    return {
      show: false,
      point: false,
      disbaled: false,
    };
  },
  props: {
    packageList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {},
  watch: {
    show(val) {
      if (val) {
        this.checkBtn();
      }
    },
  },
  methods: {
    handleClose() {
      this.show = false;
    },
    async toBuy() {
      if (!this.checkProduct()) return;
      if (this.point) return;
      this.point = true;
      console.log(this.packageList);
      const choosePackageList = this.packageList.map((data) => ({
        packageId: data.packageId,
        packageName: data.name,
        chooseProductList:
          data.status === 5
            ? data.mandatoryCourse.map((item) => ({
                productId: item.productId,
                productName: item.productName,
                productSkuId: item.productSkuId,
              }))
            : [],
        choosePackageGroupList: data.optionCourse.map((item) => ({
          groupId: item.groupInfo.groupId,
          groupName: item.groupInfo.name,
          chooseProductList: item.groupSlectedCourse.map((child) => ({
            productId: child.productId,
            productName: child.name,
            productSkuId: child.productSkuId,
          })),
        })),
      }));
      console.log(choosePackageList);
      const result = await resCourseTmall({
        choosePackageList,
        terminalMark: this.$global.terminalMark,
        tid: this.$parent.tmallCard,
        channelType: this.$parent.selected + 1,
        courseType: 2,
      });
      if (result?.code === 0) {
        this.show = false;
        this.$parent.tmallCard = '';
        this.$parent.selected = -1;
        this.$emit('success', result?.data);
      } else {
        this.$toast(result?.msg);
      }
      setTimeout(() => {
        this.point = false;
      }, 1000);
    },
    checkProduct() {
      // 检查分组产品是否都已按照规定选择
      let findRes = null;
      this.packageList.find((item) => {
        const { optionCourse, packageGroupOptionList } = item;
        if (optionCourse) {
          // 必选产品+分组 ，必选产品
          optionCourse.find((child) => {
            const { disbaled } = child;
            if (!disbaled) {
              findRes = Object.assign(child, item);
            }
            return findRes;
          });
        } else if (packageGroupOptionList?.length) {
          // 只包含产品分组的 默认没有optionCourse字段
          const groupInfo = packageGroupOptionList[0];
          Object.assign(item, { groupInfo });
          findRes = item;
          return item;
        }
        return findRes;
      });
      if (findRes) {
        this.$toast(
          `【${findRes.name}】${findRes.groupInfo.name}中必须选择${findRes.groupInfo.selectProductNum}个产品`,
        );
        return false;
      }
      return true;
    },
    receiveCourse(course) {
      const { setId, productSkuId } = course;
      this.productList.forEach((item) => {
        if (item.setId === setId) {
          Object.assign(item, { productSkuId });
        }
      });
    },
    receivePackageCourse(data) {
      this.packageList.forEach((item) => {
        if (item.packageId === data.packageId) {
          Object.assign(item, { ...data });
        }
      });
    },
    checkBtn() {
      this.packageList.forEach((item) => {
        if (item.packageProductOptionList) {
          this.disbaled = item.packageProductOptionList?.find(
            (ele) => ele.isBuy || ele.isExpire || ele.isOffline || ele.isSoldOut,
          );
        }
      });
      console.log(this.disbaled, 8899);
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.course-sku {
  ::v-deep .van-popup--bottom.van-popup--round {
    border-radius: 7px 7px 0 0 !important;
  }
}

.course-title {
  position: fixed;
  z-index: 100;
  width: 100%;
  padding: 20px 0;
  color: #333;
  font-weight: 500;
  font-size: 33px;
  line-height: 45px;
  text-align: center;
  background: #f9f9f9;
  ::v-deep .van-icon {
    position: absolute;
    top: 14px;
    right: 18px;
    color: #333;
  }
}
.course-box {
  padding: 90px 0 130px 0;
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: 120px;
  padding: 20px 0 0 0;
  background: #fff;
  button {
    display: block;
    width: 622px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    background: #ff6c02;
    border-radius: 16px;
  }
  button.active {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
